import { initializeApp } from "firebase/app";
import "./form.css";
import Cdashboard from "./dashboard/Cdashboard";
import {
  Administrator,
  Donate,
  LoginA,
} from "./Administrator/Administrator.js";
import { Assistant } from "./Assistant/Assistant";
import {
  BrowserRouter as Router,
  // Switch,
  Route,
  Routes,
  Link,
  Redirect,
} from "react-router-dom";

import React from "react";
import house from "./imgs/househelp1.png";
import Header from "./Header";
import { FullPaymentPage } from "./request/Request";
import { PaymentPage } from "./request/customer_details/Customer";
import Home from "./home/Home.js";
// import { GuarantorDetails ,Signup } from './home/Signup';
import { Signup, SignupPaymentPage } from "./home/Signup";
import Dashboard from "./dashboard/dashboard";
import Login from "./home/Login";
import { Customer } from "./request/customer_details/Customer";
import {
  Request,
  Fulltime,
  Partime,
  FullPaymentComplete,
  Guarantordetails,
  HelpRegistrationPayment,
} from "./request/Request";
import Location from "./Administrator/Location";
import { getDatabase, ref, push, onValue } from "firebase/database";
import { Rsignup } from "./Assistant/Rsignup";
import {ALogin,ASignup} from "./Assistant/ALogin";
const firebaseConfig = {
  apiKey: "AIzaSyBk-m6q2o1dKuggqoNxjoKZHmXeMSHhjsA",
  authDomain: "PROJECT_ID.firebaseapp.com",
  databaseURL: "https://househelps2-default-rtdb.firebaseio.com/",
  projectId: "househelps2",
  storageBucket: "househelps2.appspot.com",
  messagingSenderId: "SENDER_ID",
  appId: "APP_ID",
};

const app = initializeApp(firebaseConfig);
// const database = getDatabase();

var submit = document.querySelector("#sumbit_button");

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/Signup" element={  <Signup />}/>
           
          
          <Route path="/Signuppay"   element={ <SignupPaymentPage />  }/>
            
          
          <Route path="/donate" element={ <Donate />}/>
           
         
          <Route path="/guarantor"  element={<Guarantordetails />}/>
            
         

          <Route path="/Admin" element={<LoginA />}/>
            
         
          <Route path="/location" element={<Location />}/>
            
         
          <Route path="/Payment" element={<PaymentPage />}/>
            
         
          <Route path="/fullPayment" element={ <FullPaymentPage />}/>
           
         
          <Route path="/fullPaymentcomplete" element={<FullPaymentComplete />}/>
            
         

          <Route path="/Cdashboard" element={<Cdashboard />}/>
            
         

          <Route path="/customer" element={<Customer />}/>
            
         

          <Route path="/partime" element={<Partime />}/>
            
         

          <Route path="/Login" element={<Dashboard />}/>
           x
         

          <Route path="/Dashboard" element={<Dashboard />}/>
            
         
          <Route exact path="/request" element={  <Request />}/>
          
         
          <Route exact path="/fulltime" element={ <Fulltime />}/>
           
         
          <Route exact path="/fulltime" element={<Partime />}/>
            
         
          <Route exact path="/assistant" element={<Assistant />}/>
            
         
          <Route exact path="/rsignup" element={<Rsignup />}/>
            
         
          <Route exact path="/ALogin" element={<ALogin />}/>
            
         
          <Route exact path="/asignup" element={<ASignup />}/>
            
         

          <Route exact path="/" element={ <Home />}/>
           
          
        </Routes>
      </div>
    </Router>
  );
}

export default App;
